module.exports = __webpack_public_path__ + "static/adegoke-52982d837b211df094975bee008fb808.png";